import React from 'react'
import { DragObjectWithType, useDrop } from 'react-dnd'
import { CategoryIcon } from '../../../../ui/icon'
import { DragObjectTypes } from '../../dragObjects'
import styles from './Bag.module.css'
import clsx from 'clsx'

interface BagProps<T> {
    numTiles: number
    canTrade?: boolean
    onTrade?: (tile: T) => any
}

export default function Bag<T extends DragObjectWithType>(props: BagProps<T>) {
    const [{ isOver }, drop] = useDrop<T, {}, { isOver: boolean }>({
        accept: DragObjectTypes.Tile,
        canDrop: () => !!(props.canTrade && props.onTrade),
        drop: props.onTrade,
        collect: monitor => ({
            isOver: !!monitor.isOver(),
        }),
    })

    return (
        <div ref={drop} className={clsx({
            [styles.bag]: true,
            [styles.highlighted]: isOver,
        })}>
            <CategoryIcon width="1em" fill="rgba(255,255,255,.6)" />
            <div>{props.numTiles}</div>
        </div>
    )
}
